export default {"src":"/_next/static/media/Sam.d7792757.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};